module.exports = __webpack_public_path__ + "static/media/the-racer2.74873026.jpg";